module.exports = __webpack_public_path__ + "img/action-delete.3dbfa11b.svg";